module.exports = __webpack_public_path__ + "static/media/note-02.7f0dc24a.svg";